import { Component, OnInit, ViewChild } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';

import { ProdcosindfaseService } from "../prodservicios/prodcosindfase.service";
import { ProdDetcif } from "../prodinterfaces/proddetcif";

import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { DatePipe } from '@angular/common';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { isNullOrUndefined, isNull } from 'util';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { Usuario } from 'src/app/usuario';
import { ProdEnccif } from '../prodinterfaces/prodenccif';

@Component({
  selector: 'app-prodcosindfase',
  templateUrl: './prodcosindfase.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class ProdcosindfaseComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  btnNuevo: boolean;
  btnGuardar: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;
  barraBotones2: boolean
  index

  indicador: any;
  permisoprodcindfase: SegMaePermiso;




  /*busquedas*/
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  consulta: string;
  displayDialogBusquedaFast: boolean;

  public frameworkComponents;
  rowStyle;
  defaultProdDetcif;
  rowSelection = 'multiple';

  spin

  displayDialogDocumentos = false;
  boolpercont
  displayDialogReportes: boolean;
  displayAsiContable: boolean;

  auxreporte: number = 0;

  strNombreForma: string;

  asiento: any;
  auxiliar1: number;

  detcifSelected: ProdDetcif
  lblestado

  columnDefsProddetcif = [
    { // 0
      headerName: 'Cod.CostoInd.', field: 'CIN_CODIGO', cellEditor: 'cellPrueba', width: 160,
      // editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 10,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Nombre', field: 'DETCIF_DESCRIPCION', cellEditor: 'cellPrueba', width: 300, editable: (params) => {
        return false;
      },
      // editable: true,

    },
    { // 2
      headerName: 'Costo', field: 'DETCIF_COSTO', cellEditor: 'cellPrueba', width: 90, cellStyle: { textAlign: 'right' },
      // editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 10,
          tienecalculos: true,
        }
      },
    },
  ]

  constructor(
    public init: NuevoComponentService, public prodcosindfaseService: ProdcosindfaseService,
    private busquedaSer: InvbusquedaService, private datePipe: DatePipe, private permisosService: PermisosService,
    private messageService: MessageService, private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    private utilitariosService: UtilitariosService, private confIniciales: ConfInicialesService, public usuario: Usuario,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultProdDetcif = {
      width: 100,
      objeto: 'proddetcif',
      editable: true
    };
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.barraBotones2 = true;
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;

    this.index = 0;
    this.prodcosindfaseService.enccif[this.indicador] = {}
    this.prodcosindfaseService.detcif = []
    this.detcifSelected = {}
    this.lblestado = ''
    await this.getPermisos()
    const dec = await this.confIniciales.getDecimales('frmPROD_ENCORDPRO').toPromise()//subscribe((dec) => {

    if (dec !== null && Object.keys(dec).length > 0) {
      for (const decimales of dec) {

        if (decimales.NUMDEC_TIPDOC === 'trncostosind') {
          if (decimales.NUMDEC_CAMPO === 'COSTO') {
            this.prodcosindfaseService.decimalesCostoind = Number(decimales.NUMDEC_NUMDEC);
          }
        }
      }
      this.columnDefsProddetcif[2].cellEditorParams = {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: this.prodcosindfaseService.decimalesCostoind,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 10,
          tienecalculos: true,
        }
      };
      this.aggrid.refreshColumnDefs();
    }
    //});

  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoprodcindfase = data[0];
        } else {
          this.permisoprodcindfase = null;
        }
      } else {
        this.permisoprodcindfase = null;
      }
    } catch (e) {
      this.permisoprodcindfase = null;
      this.messageService.add({
        key: 'prodenccif',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  async manejarSenales(valor) {
    if (valor !== 'Nuevo' && valor !== 'Cancelar'
      && valor !== 'Primero' && valor !== 'Anterior' && valor !== 'Siguiente' && valor !== 'Ultimo'
      && valor !== 'Buscar' && valor !== 'Imprimir' && valor !== 'AsientoVer' && valor !== 'Salir'
      && valor !== 'Almacenardoc') {
      // Verifica el periodo contable
      const dia = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.getDate();
      const mes = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.getMonth();
      const anio = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.getFullYear();


      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, la fecha debe de estar dentro del período contable'
        });
        return;
      }
    }
    if (valor === 'Primero') {

      this.seleccionarRegistro('P');
    }
    if (valor === 'Anterior') {

      this.seleccionarRegistro('A');
    }
    if (valor === 'Siguiente') {

      this.seleccionarRegistro('S');
    }
    if (valor === 'Ultimo') {

      this.seleccionarRegistro('U');
    }
    if (valor === 'Nuevo') {
      if (this.permisoprodcindfase.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoprodcindfase.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoprodcindfase.PERTODO === 1) {
        this.validarGuardar();
      } else {
        if (this.permisoprodcindfase.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada'
          });
        }
      }
    }
    if (valor === 'Buscar') {
      if (this.permisoprodcindfase.PERTODO === 1) {
        this.busqueda();
      } else {
        if (this.permisoprodcindfase.PERSELECCION === 1) {
          this.busqueda();
        } else {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos para consultar, acción denegada'
          });
        }
      }
    }
    if (valor === 'Cancelar') {
      this.cancelar();
    }
    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (valor === 'Almacenardoc') {
      if (this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE !== ''
        && isNullOrUndefined(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE) === false
      ) {
        const dia = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.getDate();
      const mes = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.getMonth();
      const anio = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.getFullYear();


      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.boolpercont = true;
      } else {
        this.boolpercont = false;
      }

        const usu = await this.confIniciales.obtenerPermisoUsuario(this.usuario.identificacion);
        if (usu[0].USU_ALMACENARDOC === 1 || usu[0].USU_VISUALIZARDOC === 1) {
          this.displayDialogDocumentos = true;
        } else {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'info',
            summary: 'Información',
            detail: 'No tiene los permisos necesarios. Consulte con el Administrador del Sistema'
          });
        }
      }
    }
    if (valor === 'Asiento') {
      const trncomprobante = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE


      if (isNullOrUndefined(trncomprobante) || trncomprobante === '') {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'info',
          summary: 'Información',
          detail: 'Deebe guardar primero la información'
        });
        return
      }
      this.generarAsiento();
    }
    if (valor === 'AsientoVer') {
      this.verAsiento();
    }
    if (valor === 'Borrar') {
      if (this.permisoprodcindfase.PERTODO === 1) {
        const data = await this.prodcosindfaseService.getestadoordpro(this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO)
        if (data !== null && Object.keys(data).length > 0) {
          for (const iterator of data) {
            if (iterator.ENCORDPRO_ESTADO !== 'P') {
              this.messageService.add({
                key: 'prodenccif',
                severity: 'error',
                summary: 'Información',
                detail: 'No se puede eliminar todo el registro, porque la orden de producción ya está ingresada'
              });
              return;
            }
          }
        }
        if (this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_ESTADO !== 'P') {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'error',
            summary: 'Información',
            detail: 'No se puede eliminar todo el registro porque la orden de producción ya está ingresada'
          });
          return
        }
        this.borrar();
      } else {
        if (this.permisoprodcindfase.PERELIMACION === 1) {
          const data = await this.prodcosindfaseService.getestadoordpro(this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO)
          if (data !== null && Object.keys(data).length > 0) {
            for (const iterator of data) {
              if (iterator.ENCORDPRO_ESTADO !== 'P') {
                this.messageService.add({
                  key: 'prodenccif',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No se puede eliminar todo el registro, porque la orden de producción ya está ingresada/terminada'
                });
                return;
              }
            }
          }
          if (this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_ESTADO !== 'P') {
            this.messageService.add({
              key: 'prodenccif',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar todo el registro porque la orden de producción ya está ingresada'
            });
            return
          }
          this.borrar();
        } else {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }

    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  borrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'Confirmacionprodenccif',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {

          let numero = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE

          this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE = ''
          await this.prodcosindfaseService.borrarRegistro(numero)
          await this.auditoriagral.registrarAuditoria('PROD_ENCCIF',
            numero + '/Ordpro:' + this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO + '/Centra:' + this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO, 'E',
            '', '01', '', '', '', '').toPromise();
          await this.cancelar()
          this.messageService.add({
            key: 'prodenccif',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se eliminó de forma correcta'
          });

        } catch (error) {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante la eliminación ' + error
          });
          this.spin = false
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async generarAsiento() {
    try {
      this.spin = true
      await this.prodcosindfaseService.generarasiento(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE)
      this.messageService.add({
        key: 'prodenccif',
        severity: 'success',
        summary: 'Información',
        detail: 'El asiento se generó con éxito'
      });
      await this.encontrarregistro(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE)
    } catch (error) {
      this.messageService.add({
        key: 'prodenccif',
        severity: 'info',
        summary: 'Información',
        detail: 'Hubo un error al generar el asiento'
      });
      console.log(error)
      return
    }
  }
  verAsiento() {
    this.asiento = this.prodcosindfaseService.enccif[this.indicador].ASI_NRO;
    if (this.asiento === null || this.asiento === undefined || this.asiento === '') {
      this.messageService.add({
        key: 'prodenccif',
        severity: 'error',
        summary: 'Información',
        detail: 'No ha generado el Asiento Contable'
      });
    } else {
      this.auxiliar1++;
      // this.displayDialogAsiento = true;
      this.displayAsiContable = true;
    }
  }
  seleccionarRegistro(strTipo) {

    if (strTipo === 'P') {
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'A' || strTipo === 'S') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'U') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = false;
      this.botonUltimo = false;
    }
    let numero = isNullOrUndefined(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE) ? '' : this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE
    this.prodcosindfaseService.seleccionarRegistro(strTipo, numero).subscribe((datos: any[]) => {
      if (datos !== null && datos.length > 0) {
        this.encontrarregistro(datos[0].ENCCIF_COMPROBANTE);
        //this.encontrarFactura(datos[0], 'sR');
      }
    }, error1 => {

      this.messageService.add({
        key: 'prodenccif',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al buscar la información' + error1
      });
    });
  }

  async busqueda() {
    this.opcionbusqueda = 'BUSCARREG';
    this.types = [
      { label: 'Número', value: 'ENCCIF_COMPROBANTE' },
      { label: 'FECHA', value: 'ENCCIF_FECHAEMISION' },
      { label: 'Comentario', value: 'ENCCIF_COMENTARIO' },
      { label: 'Ord. PRoducción', value: 'ENCORDPRO_NUMERO' },
      { label: 'Centro Trabajo', value: 'CENTRA_CODIGO' },

    ];
    this.busquedacampos = ['', '', '', '', ''];
    this.tabla = 'PROD_ENCCIF';
    this.where = ' ENCCIF_COMPROBANTE is not null order by ENCCIF_FECHAEMISION desc ';
    this.busquedaSer.busquedaRegProdenccif().subscribe((res: any[]) => {
      this.arregloCons = res;
      this.arregloCons.map((dato) => {
        if (dato.ENCCIF_FECHAEMISION !== null) {
          dato.ENCCIF_FECHAEMISION = this.datePipe.transform(dato.ENCCIF_FECHAEMISION, 'dd/MM/yyyy');
        } else {
          dato.ENCCIF_FECHAEMISION = '';
        }
      });
      this.displayDialogBusquedaFast = true;
    });
  }
  async validarGuardar() {
    try {
      this.spin = true
      const data = await this.busquedaSer.busquedaCentrabcif(this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO).toPromise()
      const coscincod = Array.from(new Set(this.prodcosindfaseService.detcif.map(item => String(item.CIN_CODIGO)).filter(x => x === null && String(x).trim() === '')));
      const data2 = await this.prodcosindfaseService.getestadoordpro(this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO)
      if (data2 !== null && Object.keys(data2).length > 0) {
        for (const iterator of data2) {
          if (iterator.ENCORDPRO_ESTADO !== 'P') {
            this.messageService.add({
              key: 'prodenccif',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede guardar el registro, porque la orden de producción ya está ingresada'
            });
            return;
          }
        }
      }
      if (this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_ESTADO !== 'P') {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'No se puede guardar el registro porque la orden de producción ya está ingresada'
        });
        return
      }
      if (this.prodcosindfaseService.detcif.length === 0) {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'El detalle no puede estar vacío'
        });
        this.spin = false;
        return
      }
      if (coscincod.length > 0) {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'Existen registros con el campo cod.Costoind vacío'
        });
        this.spin = false;
        return
      }
      if (this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION === '' ||
        isNullOrUndefined(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION)
      ) {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'La fecha no puede estar vacía'
        });
        this.spin = false;
        return
      }
      if (this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO === '' ||
        isNullOrUndefined(this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO)
      ) {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'La orden de producción no puede estar vacía'
        });
        this.spin = false;
        return
      }
      if (this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO === '' ||
        isNullOrUndefined(this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO)
      ) {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'El centro de trabajo no puede estar vacío'
        });
        this.spin = false;
        return
      }
      const conteonum = this.prodcosindfaseService.detcif.map(item => (item.CIN_CODIGO)).reduce((acc, numero) => {
        acc[numero] = (acc[numero] || 0) + 1;
        return acc
      }, {});
      const reducenum = Object.entries(conteonum).map(([numero, cantidad]) => ({ numero, cantidad }));


      for (const iterator of reducenum) {
        if (iterator.cantidad > 1) {
          this.messageService.add({
            key: 'prodenccif',
            severity: 'error',
            summary: 'Información',
            detail: 'El cod.Costoind: ' + iterator.numero + ', está repetido'
          });
          this.spin = false;
          return
        }
      }
      if (data === null || Object.keys(data).length === 0) {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'El centro de trabajo:' + this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO + ', no existe'
        });
        this.spin = false;
        return
      }
      await this.finalmenteguardar()
    } catch (error) {
      this.messageService.add({
        key: 'prodenccif',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar la información antes de guardar'
      });
      console.log(error)
      this.spin = false
    }
  }
  async finalmenteguardar() {
    try {
      this.spin = true
      const numero = this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE
      if (numero === '') {
        if (this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.toString().includes('-')) {
          this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION = this.datePipe.transform(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION, 'dd/MM/yyyy')
        }
        const data = await this.prodcosindfaseService.guardarenccif(this.prodcosindfaseService.enccif[this.indicador])
        if (data !== null && Object.keys(data).length > 0) {

          for (const iterator of data) {
            this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE = iterator.NUMERO
            await this.auditoriagral.registrarAuditoria('PROD_ENCCIF',
              iterator.NUMERO + '/Ordpro:' + this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO + '/Centrab:' +
              this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO, 'I', '', '01', '', '', '', '').toPromise();

            const areglodet = this.prodcosindfaseService.detcif.map(({
              COM_CODIGO, DETCIF_LINEA, CIN_CODIGO, DETCIF_DESCRIPCION,
              DETCIF_COSTO
            }) => ({
              p_ENCCIF_COMPROBANTE: iterator.NUMERO,
              p_COM_CODIGO: COM_CODIGO,
              p_DETCIF_LINEA: Number(DETCIF_LINEA),
              p_CIN_CODIGO: CIN_CODIGO,
              p_DETCIF_DESCRIPCION: DETCIF_DESCRIPCION,
              p_DETCIF_COSTO: this.utilitariosService.redondear(DETCIF_COSTO, this.prodcosindfaseService.decimalesCostoind),
              p_USU_identificacion_4: this.prodcosindfaseService.usuario.identificacion,
              p_AUD_equipo: this.utilitariosService.getHostname(),
              p_AUD_ippublica: this.utilitariosService.getIpFrontend()
            }))
            await this.prodcosindfaseService.insertarregistrodet(areglodet)
            await this.prodcosindfaseService.generarasiento(iterator.NUMERO)
          }
          this.messageService.add({
            key: 'prodenccif',
            severity: 'success',
            summary: 'Información',
            detail: 'Éxito al guardar '
          });
          await this.cancelar();
        }
      } else if (numero !== '' && isNullOrUndefined(numero) === false) {
        if (this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION.toString().includes('-')) {
          this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION = this.datePipe.transform(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_FECHAEMISION, 'dd/MM/yyyy')
        }
        const data = await this.prodcosindfaseService.actualizaenccif(this.prodcosindfaseService.enccif[this.indicador])
        if (data !== null && Object.keys(data).length > 0) {
          for (const iterator of data) {
            this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE = iterator.NUMERO
            await this.auditoriagral.registrarAuditoria('PROD_ENCCIF',
              iterator.NUMERO + '/Ordpro:' + this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO + '/Centrab:' +
              this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO, 'A', '', '01', '', '', '', '').toPromise();

            let filtroact = this.prodcosindfaseService.detcif.filter(x => x.DETCIF_LINEA > 0)
            let filtronew = this.prodcosindfaseService.detcif.filter(x => x.DETCIF_LINEA === 0)

            const areglodetnew = filtronew.map(({
              COM_CODIGO, DETCIF_LINEA, CIN_CODIGO, DETCIF_DESCRIPCION,
              DETCIF_COSTO
            }) => ({
              p_ENCCIF_COMPROBANTE: iterator.NUMERO,
              p_COM_CODIGO: COM_CODIGO,
              p_DETCIF_LINEA: Number(DETCIF_LINEA),
              p_CIN_CODIGO: CIN_CODIGO,
              p_DETCIF_DESCRIPCION: DETCIF_DESCRIPCION,
              p_DETCIF_COSTO: this.utilitariosService.redondear(DETCIF_COSTO, this.prodcosindfaseService.decimalesCostoind),
              p_USU_identificacion_4: this.prodcosindfaseService.usuario.identificacion,
              p_AUD_equipo: this.utilitariosService.getHostname(),
              p_AUD_ippublica: this.utilitariosService.getIpFrontend()
            }))
            const areglodetact = filtroact.map(({
              COM_CODIGO, DETCIF_LINEA, CIN_CODIGO, DETCIF_DESCRIPCION,
              DETCIF_COSTO
            }) => ({
              p_ENCCIF_COMPROBANTE: iterator.NUMERO,
              p_COM_CODIGO: COM_CODIGO,
              p_CIN_CODIGO: CIN_CODIGO,
              p_DETCIF_COSTO: this.utilitariosService.redondear(DETCIF_COSTO, this.prodcosindfaseService.decimalesCostoind),
              p_USU_identificacion_4: this.prodcosindfaseService.usuario.identificacion,
              p_AUD_equipo: this.utilitariosService.getHostname(),
              p_AUD_ippublica: this.utilitariosService.getIpFrontend()
            }))
            if (areglodetnew.length > 0) {
              await this.prodcosindfaseService.insertarregistrodet(areglodetnew)
              await this.prodcosindfaseService.generarasiento(iterator.NUMERO)
            }
            if (areglodetact.length > 0) {
              await this.prodcosindfaseService.actualizaregistrodet(areglodetact)
              await this.prodcosindfaseService.generarasiento(iterator.NUMERO)
            }
          }
          this.messageService.add({
            key: 'prodenccif',
            severity: 'success',
            summary: 'Información',
            detail: 'Éxito al guardar '
          });
          await this.cancelar();
        }
      } else {
        this.spin = false
      }
    } catch (error) {
      this.messageService.add({
        key: 'prodenccif',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al gurdar la información'
      });
      console.log(error)
      this.spin = false
    }
  }
  cancelar() {
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.index = 0;
    document.getElementById('contorno').style.pointerEvents = 'none';
    if (this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE === ''
      || isNullOrUndefined(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE)
    ) {
      this.prodcosindfaseService.enccif[this.indicador] = {};
      this.prodcosindfaseService.detcif = [];
      this.aggrid.habilitarGrid();
    } else {
      this.encontrarregistro(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE)
    }
  }
  nuevo() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;

    this.prodcosindfaseService.enccif[this.indicador] = {
      ASI_NRO: '', COM_CODIGO: '01', CENTRA_CODIGO: '',
      ENCCIF_FECHAEMISION: new Date(), CENTRA_DESCRIPCION: '', ENCCIF_COMENTARIO: '',
      ENCCIF_COMPROBANTE: '', ENCORDPRO_NUMERO: '', ENCCIF_TOTAL: Number(0).toFixed(2)
    }
    this.prodcosindfaseService.detcif = [];
    this.detcifSelected = {}
    this.lblestado = '';
    document.getElementById('contorno').style.pointerEvents = 'all';
    this.aggrid.habilitarGrid();
    setTimeout(() => {
      document.getElementById('ENCORDPRO_NUMERO').focus();
    }, 100);
  }
  changeTabs() { }

  botonesmodificar() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
  }

  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'ENCORDPRO_NUMERO': {
        this.busqueOrdenProd(event.target.value)
        break;
      }
      case 'CENTRA_CODIGO': {
        this.busqueCenTrab(event.target.value)
        break;
      }
      default: {
        break;
      }
    }
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  busqueOrdenProd(opcion) {
    this.opcionbusqueda = 'ORDENPROD';
    this.types = [
      { label: 'Orden', value: 'ENCORDPRO_NUMERO' },
      { label: 'Referencia', value: 'ENCORDPRO_REFERENCIA' },
      { label: 'Fecha Emi.', value: 'ENCORDPRO_FECHAEMISION' },
      { label: 'Fecha Inicio', value: 'ENCORDPRO_FECHAINICIO' },
      { label: 'Estado', value: 'ENCORDPRO_ESTADO' }
    ];
    let parametro = isNullOrUndefined(opcion) ? '' : opcion;

    this.busquedacampos = [parametro, '', '', '', ''];
    //this.consulta = '*';
    this.tabla = 'PROD_ENCORDPRO';
    this.where = ' ENCORDPRO_ESTADO=\'P\' AND ENCORDPRO_TIPOPROD=\'P\' ';


    this.busquedaSer.busquedaProdencordcif(parametro).subscribe((eR: any[]) => {
      if (eR !== null) {
        if (Object.keys(eR).length === 1) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaProdencordcifparams(parametro).subscribe((res: any[]) => {
            if (res !== null && Object.keys(res).length > 0) {
              for (const iterator of res) {
                if (iterator.ENCORDPRO_FECHAEMISION !== null) {
                  iterator.ENCORDPRO_FECHAEMISION = this.datePipe.transform(iterator.ENCORDPRO_FECHAEMISION, 'dd/MM/yyyy');
                } else {
                  iterator.ENCORDPRO_FECHAEMISION = '';
                }
                if (iterator.ENCORDPRO_FECHAINICIO !== null) {
                  iterator.ENCORDPRO_FECHAINICIO = this.datePipe.transform(iterator.ENCORDPRO_FECHAINICIO, 'dd/MM/yyyy');
                } else {
                  iterator.ENCORDPRO_FECHAINICIO = '';
                }
              }
              this.arregloCons = res;
              this.displayDialogBusquedaFast = true;
            }
          });
        }
      } else {
        this.busquedaSer.busquedaProdencordcifparams(parametro).subscribe((res: any[]) => {
          if (res !== null && Object.keys(res).length > 0) {
            for (const iterator of res) {
              if (iterator.ENCORDPRO_FECHAEMISION !== null) {
                iterator.ENCORDPRO_FECHAEMISION = this.datePipe.transform(iterator.ENCORDPRO_FECHAEMISION, 'dd/MM/yyyy');
              } else {
                iterator.ENCORDPRO_FECHAEMISION = '';
              }
              if (iterator.ENCORDPRO_FECHAINICIO !== null) {
                iterator.ENCORDPRO_FECHAINICIO = this.datePipe.transform(iterator.ENCORDPRO_FECHAINICIO, 'dd/MM/yyyy');
              } else {
                iterator.ENCORDPRO_FECHAINICIO = '';
              }
            }
            this.arregloCons = res;
            this.displayDialogBusquedaFast = true;
          }
        });
      }
    });
  }
  busqueCenTrab(opcion) {
    this.opcionbusqueda = 'CENTROTRAB';
    this.types = [
      { label: 'Código', value: 'CENTRA_CODIGO' },
      { label: 'Descripción', value: 'CENTRA_DESCRIPCION' }
    ];
    let parametro = isNullOrUndefined(opcion) ? '' : opcion;

    this.busquedacampos = [parametro, ''];
    //this.consulta = '*';
    this.tabla = 'PROD_MAECENTRA';
    this.where = '';


    this.busquedaSer.busquedaCentrabcif(parametro).subscribe((eR: any[]) => {
      if (eR !== null) {
        if (Object.keys(eR).length === 1) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaCentrabcifparams(parametro).subscribe((res: any[]) => {
            if (res !== null && Object.keys(res).length > 0) {

              this.arregloCons = res;
              this.displayDialogBusquedaFast = true;
            }
          });
        }
      } else {
        this.busquedaSer.busquedaCentrabcifparams(parametro).subscribe((res: any[]) => {
          if (res !== null && Object.keys(res).length > 0) {

            this.arregloCons = res;
            this.displayDialogBusquedaFast = true;
          }
        });
      }
    });
  }
  async seleccionItem(params) {
    if (params === 'nuevo') {

      this.nuevodetcif()
      return;
    }
    if (params === 'eliminar') {
      const data = await this.prodcosindfaseService.getestadoordpro(this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO)
      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          if (iterator.ENCORDPRO_ESTADO !== 'P') {
            this.messageService.add({
              key: 'prodenccif',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar el registro, porque la orden de producción ya está ingresada/'
            });
            return;
          }
        }
      }
      if (this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_ESTADO !== 'P') {
        this.messageService.add({
          key: 'prodenccif',
          severity: 'error',
          summary: 'Información',
          detail: 'No se puede eliminar el registro porque la orden de producción ya está ingresada'
        });
        return
      }
      this.eliminadetcif()
      return;
    }
    if (params.object !== undefined) {
      this.detcifSelected = params.object;
    }

  }
  nuevodetcif() {
    const comprobante = isNullOrUndefined(this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE) ? '' : this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE
    const nuevodetcif: ProdDetcif = {
      CIN_CODIGO: '',
      COM_CODIGO: '01',
      DETCIF_COSTO: Number(0).toFixed(this.prodcosindfaseService.decimalesCostoind),
      DETCIF_DESCRIPCION: '',
      DETCIF_LINEA: 0,
      ENCCIF_COMPROBANTE: comprobante

    }
    const indi = this.prodcosindfaseService.detcif.indexOf(this.detcifSelected);
    if (indi === -1) {
      nuevodetcif.CLAVE = '1' + this.datePipe.transform(new Date(), 'ddMMyyyyHHmmss');
      this.prodcosindfaseService.detcif.push(nuevodetcif);
      this.detcifSelected = nuevodetcif;
      this.aggrid.refreshaggrid(this.prodcosindfaseService.detcif, this.defaultProdDetcif.objeto);
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
        this.defaultProdDetcif.objeto].setFocusedCell((this.prodcosindfaseService.detcif.length) - 1, 'CIN_CODIGO');
    } else {

      nuevodetcif.CLAVE = (indi + 1) + this.datePipe.transform(new Date(), 'ddMMyyyyHHmmss');

      this.prodcosindfaseService.detcif.splice(indi + 1, 0, nuevodetcif);
      this.detcifSelected = nuevodetcif;
      this.aggrid.refreshaggridindex(this.prodcosindfaseService.detcif, this.defaultProdDetcif.objeto, indi);
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultProdDetcif.objeto].setFocusedCell(indi + 1, 'CIN_CODIGO');
    }
  }
  eliminadetcif() {
    if (this.detcifSelected !== undefined && this.prodcosindfaseService.detcif.length > 0) {
      this.confirmationService.confirm({
        message: 'Está seguro de eliminar el registro?',
        header: 'Pregunta',
        icon: 'pi pi-exclamation-triangle',
        key: 'Confirmacionprodenccif',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: () => {
          try {
            this.confirmationService.close();
            if (this.detcifSelected.DETCIF_LINEA > 0) {
              this.prodcosindfaseService.eliminarDetalledetcif(this.detcifSelected, this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO,
                this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO
              );
              this.auditoriagral.registrarAuditoria('PROD_TRNCENTRA',
                this.prodcosindfaseService.enccif[this.indicador].ENCCIF_COMPROBANTE + '/Cod.Costos Ind.:' + this.detcifSelected.CIN_CODIGO
                + '/Costo:' + this.detcifSelected.DETCIF_COSTO, 'E', '', '01', '', '', '', '').subscribe();

              this.prodcosindfaseService.detcif.splice(this.prodcosindfaseService.detcif.findIndex(
                det => det.CLAVE === this.detcifSelected.CLAVE),
                1);
              this.messageService.add({
                key: 'prodenccif',
                severity: 'success',
                summary: 'Información',
                detail: 'El detalle se eliminó correctamente'
              });
              if (this.prodcosindfaseService.detcif.length > 0) {
                this.detcifSelected = this.prodcosindfaseService.detcif
                [this.prodcosindfaseService.detcif.length - 1];
              }

              this.aggrid.refreshaggrid(this.prodcosindfaseService.detcif, this.defaultProdDetcif.objeto);
            } else {
              this.prodcosindfaseService.detcif.splice(this.prodcosindfaseService.detcif.findIndex(
                detfac => detfac.CLAVE === this.detcifSelected.CLAVE),
                1);
              this.messageService.add({
                key: 'prodenccif',
                severity: 'success',
                summary: 'Información',
                detail: 'El detalle se eliminó correctamente'
              });
              if (this.prodcosindfaseService.detcif.length > 0) {
                this.detcifSelected = this.prodcosindfaseService.detcif
                [this.prodcosindfaseService.detcif.length - 1];
              }
              this.aggrid.refreshaggrid(this.prodcosindfaseService.detcif, this.defaultProdDetcif.objeto);
            }
          } catch (error) {
            this.messageService.add({
              key: 'prodenccif',
              severity: 'error',
              summary: 'Información',
              detail: 'Ocurrió un error al elimnar la linea de detalle'
            });
            console.log(error)
            return;
          }


        },
        reject: () => {
          this.confirmationService.close();
        }
      });
    }
  }
  cambio(evento) {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'ORDENPROD') {
      this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_NUMERO = opcion.ENCORDPRO_NUMERO
      this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_ESTADO = opcion.ENCORDPRO_ESTADO
      if (opcion.ENCORDPRO_ESTADO === 'P') {
        this.lblestado = 'PENDIENTE'
      } else if (opcion.ENCORDPRO_ESTADO === 'I') {
        this.lblestado = 'INGRESADA'
      }
      document.getElementById('CENTRA_CODIGO').focus();
    }
    if (this.opcionbusqueda === 'CENTROTRAB') {
      this.prodcosindfaseService.enccif[this.indicador].CENTRA_CODIGO = opcion.CENTRA_CODIGO
      this.prodcosindfaseService.enccif[this.indicador].CENTRA_DESCRIPCION = opcion.CENTRA_DESCRIPCION
      document.getElementById('ENCCIF_COMENTARIO').focus();
    }
    if (this.opcionbusqueda === 'BUSCARREG') {
      this.encontrarregistro(opcion.ENCCIF_COMPROBANTE)
    }


    this.displayDialogBusquedaFast = false
  }
  async encontrarregistro(numero) {
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.prodcosindfaseService.enccif[this.indicador] = {};
    this.prodcosindfaseService.detcif = [];
    this.detcifSelected = {}
    try {
      this.spin = true
      const data = await this.prodcosindfaseService.consultaenccif(numero)
      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          iterator.ENCCIF_FECHAEMISION = new Date(iterator.ENCCIF_FECHAEMISION)
          this.prodcosindfaseService.enccif[this.indicador] = iterator;
          const data2 = await this.prodcosindfaseService.consultadetcif(numero)
          if (iterator.ENCORDPRO_ESTADO === 'P') {
            this.lblestado = 'PENDIENTE'
          } else if (iterator.ENCORDPRO_ESTADO === 'I') {
            this.lblestado = 'INGRESADA'
          }
          if (data2 !== null && Object.keys(data2).length > 0) {
            for (const item of data2) {
              item.DETCIF_COSTO = this.utilitariosService.formatear(item.DETCIF_COSTO, this.prodcosindfaseService.decimalesCostoind)
              this.detcifSelected = item
            }
            this.prodcosindfaseService.detcif = data2
          }
          document.getElementById('contorno').style.pointerEvents = 'all';
          this.prodcosindfaseService.calculartotales();
          this.spin = false
          if (this.prodcosindfaseService.enccif[this.indicador].ENCORDPRO_ESTADO !== 'P') {
            document.getElementById('contorno').style.pointerEvents = 'none';
          }

        }
      } else {
        this.spin = false
      }
    } catch (error) {
      this.messageService.add({
        key: 'prodenccif',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar la información antes de guardar'
      });
      console.log(error)
      this.spin = false
    }

  }
  cerrarReportes() {
    this.displayDialogReportes = false
  }
  recibirSenalesDocumentos(valor) {
    if (valor === true) {
      this.displayDialogDocumentos = false;
    }
  }
  recibirSenalesConEncasil(valor) {
    if (valor === true) {
      this.displayAsiContable = false;
    }
  }
}
